export const ZOrder = {
	FLOOR: -20,
	TILE: 0,
	CARPET_LIKE: 3,
	PORTAL: 3,
	CORPSE: 15,
	LEVEL_CHANGER: 17,
	ITEM_ON_FLOOR: 20,
	SCENARIO: 100,
	FIRE: 100,
	INACTIVE_MOB: 101,
	INTERACTABLE_OBJECTS: 104,
	GOLD_DROP: 105,
	MOB: 110,
	PLAYER: 120,
	PROJECTILE: 130,
	AIR: 200,
	TOP: 99999,
} as const;
